import React from 'react';
import { Provider } from 'react-redux';
import store from './EcommerceStore';

import SequenceManager from './managers/SequenceManager';

function App() {
    return (
        <React.Suspense fallback={<div></div>}>
            <Provider store={store}>
                <SequenceManager />
            </Provider>
        </React.Suspense>
    )
}

export default App